export const colors = {
  // Brand colors
  "warm-snow-500": "#FBF9F9",
  "bgpeach-500": "#FFE1D4",
  "darkpink-500": "#CD4870",
  "pinkmain-500": "#F9709A",
  "lightpink-500": "#FCBBCB",
  "lightpink-100": "#FFF8F8",
  "lightgreen-500": "#0B564C",
  "lightgreen-100": "#F7FFF4",
  "green-500": "#02302A",
  "darkgreen-500": "#011916",
  //System colors
  "error-500": "#D6453B",
  "error-500-o005": "#D6453B0D",
  "success-500": "#63AE56",
  "warning-500": "#F5BA5C",
  "warning-500-o005": "#F5BA5C0D",
  "warning-100": "#FFF8EE",
  //Grays
  "gray-teal-100": "#CCD6D4",
  "gray-950": "#111111",
  "gray-primary-900": "#23252A",
  "gray-800": "#505360",
  "gray-650": "#636668",
  "gray-600": "#7D8291",
  "gray-600-o005": "#7D82910D",
  "gray-secondary-400": "#A1A7BA",
  "gray-200": "#CDD3DC",
  "gray-220": "#DDDDDD",
  "gray-300": "#D3D3D3",
  "gray-150": "#CBCBCC",
  "gray-100": "#E4E7EB",
  "gray-50": "#F3F5F8",

  "gray-light-50": "#F2F2F4",

  white: "#FFFFFF",

  "lightblue-700": "#3D86E0",
  "lightblue-700-010": "#3D86E01A",
  "lightblue-800": "#147AF3",

  // scores colors
  //  "scores-10-9": "#085262",
  "score-10-9": "#136D58",
  "socore-10-9-o005": "#136D580D",
  "score-8": "#309269",
  "socore-7": "#73B85B",
  "score-6": "#ADC25B",
  "score-5": "#CFCB68",
  "score-4": "#BCA34C",
  "score-3": "#DD8452",
  "score-2-1": "#E06B51",

  "mint-50": "#EFF9F6",

  "warm-light-50": "#FEF5E7",
  "warm-light-100": "#FCF0EF",
  "warm-light-150": "#FDF3F1",

  "teal-50": "#F3F8F7",
};
